
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("13uj5", function(module, exports) {
/* 
Mono
console.log('⏳ evaluating', import.meta.url);
*/ 

var $godRl = parcelRequire("godRl");

var $12U9u = parcelRequire("12U9u");

var $aJO1s = parcelRequire("aJO1s");

var $e6rpZ = parcelRequire("e6rpZ");

var $1ry19 = parcelRequire("1ry19");
parcelRequire("5weiY");

var $96Hpt = parcelRequire("96Hpt");

var $aGznl = parcelRequire("aGznl");
parcelRequire("4D2XJ");

var $hd1sz = parcelRequire("hd1sz");

var $1WKpD = parcelRequire("1WKpD");

var $3rpK2 = parcelRequire("3rpK2");

var $bpqmk = parcelRequire("bpqmk");
const $0c4d948fe6849659$export$73693bad9f5880b0 = {
    userIsLoggedIn: (0, $12U9u.userIsLoggedIn),
    init: async function() {
        console.log('auth.init');
        (0, $1WKpD.cookieConsent).init();
        // Invited pop up
        (0, $3rpK2.invitedHandler).init();
        // Init notification
        (0, $aJO1s.notification).init();
        // Check for maintenance
        if ((0, $aGznl.appMaintenance)() === true) {
            console.log('Maintenance mode detected');
            return;
        }
        // Check for email and code in URL
        $0c4d948fe6849659$export$73693bad9f5880b0.checkForURLParamater();
        // Show install hint
        if ((0, $12U9u.isLogin) || (0, $12U9u.isInstall)) (0, $96Hpt.appInstallHint)();
        // Check color scheme
        // if(localStorage.getItem('colorScheme')){
        //   document.documentElement.classList.add(`${localStorage.getItem('colorScheme')}-mode`);
        // }
        // Init error handling
        (0, $1ry19.error).init();
        // Show login, signup, or verify page
        if (0, $12U9u.isLogin) {
            (0, $12U9u.qS)('#login_email_form').addEventListener('submit', (e)=>{
                console.log('login_email_form submit');
                e.preventDefault();
                this.loginRequestCode({
                    email: (0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#login_email').value),
                    language: (0, $12U9u.pageLanguage)
                });
            });
            (0, $12U9u.qS)('#login_code_form').addEventListener('submit', (e)=>{
                e.preventDefault();
                $0c4d948fe6849659$export$73693bad9f5880b0.confirmCode((0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#login_email').value), (0, $12U9u.qS)('#login_verification_code').value.trim());
            });
            (0, $12U9u.qS)('#login_verification_code').addEventListener('input', (e)=>{
                $0c4d948fe6849659$export$73693bad9f5880b0.enableButton((0, $12U9u.qS)('#login_confirm'), (0, $12U9u.qS)('#login_verification_code'));
                if ((0, $12U9u.qS)('#login_verification_code').value.length === 6) $0c4d948fe6849659$export$73693bad9f5880b0.confirmCode((0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#login_email').value), (0, $12U9u.qS)('#login_verification_code').value);
            });
            // Remove error when typing
            (0, $12U9u.qS)('#login_email').addEventListener('input', ()=>{
                this.restart('login');
            });
        }
        if (0, $12U9u.isVerify) {
            // Verify
            (0, $12U9u.qS)('#verify_code_form').addEventListener('submit', (e)=>{
                e.preventDefault();
                $0c4d948fe6849659$export$73693bad9f5880b0.confirmCode((0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#verify_email').value), (0, $12U9u.qS)('#verify_verification_code').value, 'sign_up');
            });
            (0, $12U9u.qS)('#verify_verification_code').addEventListener('input', (e)=>{
                $0c4d948fe6849659$export$73693bad9f5880b0.enableButton((0, $12U9u.qS)('#verify_confirm'), (0, $12U9u.qS)('#verify_verification_code'));
                if ((0, $12U9u.qS)('#verify_verification_code').value.length === 6) $0c4d948fe6849659$export$73693bad9f5880b0.confirmCode((0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#verify_email').value), (0, $12U9u.qS)('#verify_verification_code').value, 'sign_up');
            });
        }
        if (0, $12U9u.isVerify) $0c4d948fe6849659$export$73693bad9f5880b0.showVerifyPage();
        if (0, $12U9u.isUnsubscribe) $0c4d948fe6849659$export$73693bad9f5880b0.showUnsubscribePage();
        (0, $12U9u.qS)('body').classList.remove('page-loading');
        try {
            await (0, $e6rpZ.activity).initAndTrackPageView();
        } catch (error) {
            console.error('activity.initAndTrackPageView failed:', error);
        }
    },
    checkForURLParamater: function() {
        console.log('auth.checkForURLParamater', (0, $12U9u.isSignUp));
        if ((0, $12U9u.isLogin) && (0, $12U9u.url).parameters.email) (0, $12U9u.qS)(`#login_email`).value = (0, $12U9u.normalizeEmail)((0, $12U9u.url).parameters.email);
        if ((0, $12U9u.isSignUp) && (0, $12U9u.url).parameters.email) {
            console.log('auth.checkForURLParamater isSignUp');
            (0, $12U9u.qS)(`#sign_up_email`).value = (0, $12U9u.normalizeEmail)((0, $12U9u.url).parameters.email);
        }
        if ((0, $12U9u.isUnsubscribe) && (0, $12U9u.url).parameters.email) (0, $12U9u.qS)('#unsubscribe_email').value = (0, $12U9u.normalizeEmail)((0, $12U9u.url).parameters.email);
        // For split tests
        if ((0, $12U9u.url).parameters.g) (0, $hd1sz.setLocalStorageItem)('splitTestGroup', (0, $12U9u.url).parameters.g);
        if ((0, $12U9u.url).parameters.code) {
            (0, $12U9u.qS)(`#login_verification_code`).value = (0, $12U9u.url).parameters.code;
            (0, $12U9u.qS)(`#login_email_container`).querySelector('.success').style.display = 'block';
            (0, $12U9u.qS)(`#login_next`).style.display = 'none';
            (0, $12U9u.qS)(`#login_code_form`).style.display = 'block';
            // Auto submit form
            this.confirmCode((0, $12U9u.normalizeEmail)((0, $12U9u.url).parameters.email), (0, $12U9u.url).parameters.code, 'sign_up');
        }
    },
    showVerifyPage: function() {
        console.log('auth.showVerifyPage');
        // User created, now verify email
        // Note: can't use url variable, because URL has changed
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email') ? (0, $12U9u.normalizeEmail)(decodeURIComponent(params.get('email'))) : null;
        if (email) {
            (0, $12U9u.qS)('#verify_copy_email').textContent = email;
            (0, $12U9u.qS)('#verify_email').value = email;
            // request login code
            $0c4d948fe6849659$export$73693bad9f5880b0.loginRequestCode({
                email: email,
                language: (0, $12U9u.pageLanguage)
            });
        } else {
            const loginHref = (0, $12U9u.publicPage)?.links?.login?.href || navigator.language === 'de' ? '/einloggen' : '/login';
            const errorMessage = encodeURIComponent((0, $12U9u.publicPage)?.text?.auth?.loginErrorInfo || 'There was an error, please try again.');
            window.location.href = `${loginHref}?info=${errorMessage}&info_type=error`;
        }
    },
    showUnsubscribePage: function() {
        const params = new URLSearchParams(window.location.search);
        const unsubscribeFromType = params.get('type') || 'all';
        console.log('auth.showUnsubscribePage unsubscribeFromType', unsubscribeFromType);
        (0, $12U9u.qS)('#unsubscribe_form').addEventListener('submit', async (e)=>{
            e.preventDefault();
            (0, $12U9u.qS)('#unsubscribe_confirm').disabled = true;
            (0, $12U9u.qS)('#unsubscribe_confirm').classList.add('button-loading');
            const unsubscribeResult = await (0, $godRl.httpsCallable)((0, $godRl.functions), 'unsubscribe')({
                email: (0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#unsubscribe_email').value),
                unsubscribeFromType: unsubscribeFromType,
                language: (0, $12U9u.pageLanguage)
            });
            (0, $12U9u.qS)('#unsubscribe_confirm').disabled = false;
            (0, $12U9u.qS)('#unsubscribe_confirm').classList.remove('button-loading');
            if (unsubscribeResult.data.success) {
                (0, $12U9u.qS)('#unsubscribe_title').textContent = (0, $12U9u.publicPage)?.text?.auth?.unsubscribedTitle || 'Unsubscribed';
                (0, $12U9u.qS)('#unsubscribe_copy').innerHTML = (0, $12U9u.publicPage)?.text?.auth?.unsubscribedCopy || 'Your email address has been unsubscribed from the list.';
                (0, $12U9u.qS)('#unsubscribe_form').style.display = 'none';
                // Track delete
                await (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.unsubscribed, {
                    email: (0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#unsubscribe_email').value)
                });
            } else (0, $aJO1s.notification).showError(unsubscribeResult.data.errorMessage);
        });
    },
    loginRequestCode: async function(recipient) {
        if (0, $12U9u.isLogin) {
            (0, $12U9u.qS)(`#login_email_form button`).classList.add('button-loading');
            (0, $12U9u.qS)(`#login_email_form button`).disabled = true;
        }
        let body = recipient;
        // Add language, needed for email 
        body.language = body.language || (0, $12U9u.publicPage)?.language || (0, $12U9u.pageLanguage) || 'en';
        try {
            const redirectedToSso = await (0, $bpqmk.redirectToSsoIfRequired)({
                email: body.email,
                flow: (0, $12U9u.isVerify) ? 'signUp' : 'login',
                redirect: (0, $12U9u.url).parameters.redirect || '/app/',
                pending: {
                    language: body.language
                }
            });
            if (redirectedToSso) return;
            const result = await (0, $godRl.httpsCallable)((0, $godRl.functions), 'requestCode')(body);
            console.log('loginRequestCode result', result);
            if (result.data.success) {
                if (0, $12U9u.isLogin) {
                    (0, $12U9u.qS)('#login_code_form').style.display = 'block';
                    (0, $12U9u.qS)('#login_next').style.display = 'none';
                    (0, $12U9u.qS)('#login_verification_code').focus();
                }
                await (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.requestedLoginCode, null);
            } else if (result.data.error === 'SSO_REQUIRED' && result.data.sso) {
                (0, $bpqmk.redirectToSsoPage)({
                    email: body.email,
                    flow: (0, $12U9u.isVerify) ? 'signUp' : 'login',
                    redirect: (0, $12U9u.url).parameters.redirect || '/app/',
                    sso: result.data.sso,
                    pending: {
                        language: body.language
                    }
                });
                return;
            } else (0, $1ry19.error).handle(result.data, `login_email_container`);
        } catch (error) {
            if (0, $12U9u.isLogin) {
                (0, $12U9u.qS)(`#login_email_form button`).classList.remove('button-loading');
                (0, $12U9u.qS)(`#login_email_form button`).disabled = false;
            }
            (0, $aJO1s.notification).showError(error);
            console.error('Error:', error);
            throw error;
        }
        if (0, $12U9u.isLogin) {
            (0, $12U9u.qS)(`#login_email_form button`).classList.remove('button-loading');
            (0, $12U9u.qS)(`#login_email_form button`).disabled = false;
        }
    },
    signInWithFirebase: function(customToken, callback, user) {
        (0, $godRl.signInWithCustomToken)((0, $godRl.firebaseAuth), customToken).then((userCredential)=>{
            (0, $hd1sz.setLocalStorageItem)('loggedIn', true);
            $0c4d948fe6849659$export$73693bad9f5880b0.userIsLoggedIn = true;
            // Redirect
            callback(user);
        }).catch((error)=>{
            const errorPrefix = (0, $12U9u.publicPage)?.text?.auth?.signInErrorPrefix || 'Error signing in with custom token:';
            alert(`${errorPrefix} ${error}`);
            console.error('Error signing in with custom token:', error);
        });
    },
    redirectAfterVerification: function(user) {
        (0, $12U9u.qS)('body').classList.add('page-loading');
        // Redirect
        const params = new URLSearchParams(window.location.search);
        const redirect = params.get('redirect');
        if (redirect) // If redirect is in URL
        window.location.href = redirect;
        else // All users
        window.location.href = "/app/";
    },
    confirmCode: async function(recipient, verificationCode, type = null) {
        verificationCode = verificationCode.toLowerCase().trim();
        (0, $12U9u.qSA)(`.code-form button`).forEach((button)=>{
            button.classList.add('button-loading');
            button.disabled = true;
        });
        const publicId = (0, $hd1sz.getLocalStorageItem)('publicId') || null;
        const body = {
            email: recipient,
            verificationCode: verificationCode,
            publicId: publicId
        };
        try {
            console.log('confirmCode request, body:', body);
            const result = await (0, $godRl.httpsCallable)((0, $godRl.functions), 'confirmCode')(body);
            console.log('confirmCode result:', result);
            if (result.data.success) {
                await (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.login, null);
                // Sign in and redirect
                $0c4d948fe6849659$export$73693bad9f5880b0.signInWithFirebase(result.data.customToken, $0c4d948fe6849659$export$73693bad9f5880b0.redirectAfterVerification, result.data.user);
            } else {
                (0, $12U9u.qS)(`.code-form button`).classList.remove('button-loading');
                (0, $12U9u.qS)(`.code-form button`).disabled = false;
                if (result.data.reset) {
                    if (0, $12U9u.isLogin) {
                        (0, $aJO1s.notification).showError((0, $12U9u.publicPage)?.text?.auth?.tooManyAttempts || 'The code was entered incorrectly too many times. Please request a new code.');
                        this.restart('login');
                    } else {
                        const loginHref = (0, $12U9u.publicPage)?.links?.login?.href || navigator.language === 'de' ? '/einloggen' : '/login';
                        const info = encodeURIComponent((0, $12U9u.publicPage)?.text?.auth?.tooManyAttempts || 'The code was entered incorrectly too many times. Please request a new code.');
                        window.location.href = `${loginHref}?email=${encodeURIComponent(recipient)}&info=${info}&info_type=error`;
                    }
                } else {
                    (0, $1ry19.error).handle(result.data, `login_verification_code_container`);
                    (0, $1ry19.error).handle(result.data, `verify_verification_code_container`);
                }
            }
        } catch (error) {
            (0, $12U9u.qS)(`.code-form button`).classList.remove('button-loading');
            (0, $12U9u.qS)(`.code-form button`).disabled = false;
            const errorPrefix = (0, $12U9u.publicPage)?.text?.auth?.genericRequestErrorPrefix || 'Error:';
            (0, $aJO1s.notification).showError(`${errorPrefix} ${error}`);
            console.error('Error:', error);
            throw error;
        }
    },
    restart: function(formType) {
        const formContainer = (0, $12U9u.qS)(`#${formType}_email_container`);
        formContainer.querySelector('.success').style.display = 'none';
        formContainer.classList.remove('input-error');
        (0, $1ry19.error).handle({
            success: false
        }, `${formType}_verification_code_container`);
        (0, $12U9u.qS)(`#${formType}_next`).style.display = 'block';
        (0, $12U9u.qS)(`#${formType}_code_form`).style.display = 'none';
        (0, $12U9u.qS)(`#${formType}_verification_code`).value = '';
    },
    enableButton: function(button, input) {
        button.disabled = input.value.length !== 6;
    },
    updateUIAfterCodeSent: function(result) {
        const container = (0, $12U9u.qS)(`#login_email_container`);
        if (result.success) {
            container.querySelector('.success').style.display = 'block';
            (0, $12U9u.qS)(`#login_next`).style.display = 'none';
            (0, $12U9u.qS)(`#login_code_form`).style.display = 'block';
        } else (0, $1ry19.error).handle(result, `#login_email_container`);
    }
};
window.auth = $0c4d948fe6849659$export$73693bad9f5880b0;
let $0c4d948fe6849659$var$authInitStarted = false;
const $0c4d948fe6849659$var$startAuth = ()=>{
    if ($0c4d948fe6849659$var$authInitStarted) return;
    $0c4d948fe6849659$var$authInitStarted = true;
    $0c4d948fe6849659$export$73693bad9f5880b0.init().catch((error)=>{
        console.error('auth.init failed:', error);
    });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $0c4d948fe6849659$var$startAuth, {
    once: true
});
else $0c4d948fe6849659$var$startAuth();
window.addEventListener('pageshow', $0c4d948fe6849659$var$startAuth);

});
parcelRegister("1ry19", function(module, exports) {

$parcel$export(module.exports, "error", () => $10d2b33a37aefefa$export$a3bc9b8ed74fc);
/* 
Mono
console.log('⏳ evaluating', import.meta.url);
*/ 
var $12U9u = parcelRequire("12U9u");
const $10d2b33a37aefefa$export$a3bc9b8ed74fc = {
    init: function() {
        qSA('.handle-error').forEach((container)=>{
            container.querySelector('input').addEventListener('input', function() {
                container.classList.remove('input-error');
                if (container.querySelector('.error')) container.querySelector('.error').remove();
            });
        });
    },
    handle: async function(result, container) {
        // If string is passed, get the element
        if (typeof container === "string") container = (0, $12U9u.qS)("#" + container);
        if (!container) {
            console.error('Container not found');
            return;
        }
        if (result.error) {
            container.classList.add('input-error');
            let errorMessage = result.errorMessage || result.error;
            console.log('errorMessage', errorMessage);
            if (!container.querySelector('.error')) {
                let errorContainer = document.createElement('div');
                errorContainer.classList.add('error');
                container.appendChild(errorContainer);
            }
            container.querySelector('.error').innerHTML = errorMessage;
            container.querySelector('.error').style.display = "block";
            // Enable submit button
            const submitButton = container.closest('form').querySelector('button[type="submit"]');
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.classList.remove('button-loading');
            }
            if (typeof activity !== 'undefined') activity.log(activity.activityTypes.errorSeen, result.error);
        } else if (container) container.classList.remove('input-error');
    }
};
// Expose profile to the global object
window.error = $10d2b33a37aefefa$export$a3bc9b8ed74fc;

});

parcelRegister("5weiY", function(module, exports) {
/* 
Mono
console.log('⏳ evaluating', import.meta.url);
*/ // Import project modules

var $12U9u = parcelRequire("12U9u");

var $e6rpZ = parcelRequire("e6rpZ");

var $1ry19 = parcelRequire("1ry19");

var $8Mqxj = parcelRequire("8Mqxj");
parcelRequire("13uj5");

var $hd1sz = parcelRequire("hd1sz");

var $bpqmk = parcelRequire("bpqmk");

var $4D2XJ = parcelRequire("4D2XJ");

var $jdIi8 = parcelRequire("jdIi8");

var $aMSjD = parcelRequire("aMSjD");

var $4CIFe = parcelRequire("4CIFe");
const $404b099c73bb3a1f$var$recaptchaBlockedErrorMessage = (0, $12U9u.publicPage)?.text?.signUpForm?.recaptchaBlockedErrorMessage || 'Google reCAPTCHA could not be loaded. Ad blockers and privacy extensions can block it. Please allow mono.chat and google.com, then try again.';
const $404b099c73bb3a1f$var$recaptchaLoadingErrorMessage = (0, $12U9u.publicPage)?.text?.signUpForm?.recaptchaLoadingErrorMessage || 'Security check is still loading. Please wait a moment and try again.';
const $404b099c73bb3a1f$var$requestTimeoutErrorMessage = (0, $12U9u.publicPage)?.text?.signUpForm?.requestTimeoutErrorMessage || 'Something went wrong. Turn off your ad blocker, and try again.';
const $404b099c73bb3a1f$var$honeypotErrorMessage = (0, $12U9u.publicPage)?.text?.signUpForm?.honeypotErrorMessage || 'Something went wrong. Please try again.';
const $404b099c73bb3a1f$var$renderSignUpLead = function() {
    const signUpLead = (0, $12U9u.qS)('#sign_up_lead');
    if (!signUpLead) return;
    const country = (0, $hd1sz.getLocalStorageItem)((0, $jdIi8.currency).localStorageItemNameCountry);
    const copy = (0, $4CIFe.countryHasFreeMessages)(country) ? (0, $12U9u.publicPage)?.text?.auth?.signUpLead : (0, $12U9u.publicPage)?.text?.auth?.signUpLeadNoAllowance;
    if (copy) signUpLead.textContent = copy;
};
const $404b099c73bb3a1f$var$resetSignUpButton = function() {
    const signUpButton = (0, $12U9u.qS)('#sign_up_next');
    if (!signUpButton) return;
    signUpButton.classList.remove('button-loading');
    signUpButton.disabled = false;
};
const $404b099c73bb3a1f$var$showRecaptchaBlockedError = function() {
    const errorMessage = window.recaptchaLoadState === 'loading' ? $404b099c73bb3a1f$var$recaptchaLoadingErrorMessage : $404b099c73bb3a1f$var$recaptchaBlockedErrorMessage;
    (0, $1ry19.error).handle({
        error: 'RECAPTCHA_BLOCKED',
        errorMessage: errorMessage
    }, 'sign_up_terms_container');
    $404b099c73bb3a1f$var$resetSignUpButton();
};
const $404b099c73bb3a1f$var$showTimeoutError = function() {
    (0, $1ry19.error).handle({
        error: 'TIMEOUT_ERROR',
        errorMessage: $404b099c73bb3a1f$var$requestTimeoutErrorMessage
    }, 'sign_up_terms_container');
    $404b099c73bb3a1f$var$resetSignUpButton();
};
const $404b099c73bb3a1f$var$isTimeoutError = function(err) {
    if (typeof err === 'string') return err === 'Timeout';
    if (!err || typeof err !== 'object') return false;
    return err.message === 'Timeout' || err.code === 'functions/deadline-exceeded';
};
const $404b099c73bb3a1f$var$isBrowserInteropUpdateError = function(err) {
    const message = typeof err === 'string' ? err : err?.message;
    if (typeof message !== 'string') return false;
    return message.startsWith('Object Not Found Matching Id:') && message.includes('MethodName:update');
};
const $404b099c73bb3a1f$var$initSignUpRecaptchaGuard = function() {
    const signUpForm = (0, $12U9u.qS)('#sign_up_email_form');
    if (!signUpForm) return;
    signUpForm.addEventListener('submit', (event)=>{
        const recaptchaReady = typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.execute === 'function';
        if (recaptchaReady) return;
        event.preventDefault();
        // Retry loading in case extensions or network timing delayed script availability.
        if (typeof window.loadRecaptcha === 'function') window.loadRecaptcha();
        $404b099c73bb3a1f$var$showRecaptchaBlockedError();
    });
};
const $404b099c73bb3a1f$var$initSignUpUnhandledRejectionGuard = function() {
    const signUpForm = (0, $12U9u.qS)('#sign_up_email_form');
    if (!signUpForm) return;
    window.addEventListener('unhandledrejection', (event)=>{
        const reason = event?.reason;
        if ($404b099c73bb3a1f$var$isTimeoutError(reason)) {
            // reCAPTCHA/Firebase can reject with raw "Timeout" outside local catch blocks.
            event.preventDefault?.();
            $404b099c73bb3a1f$var$showTimeoutError();
            return;
        }
        if ($404b099c73bb3a1f$var$isBrowserInteropUpdateError(reason)) // Ignore known browser-extension interop noise on the auth page.
        event.preventDefault?.();
    });
};
$404b099c73bb3a1f$var$initSignUpRecaptchaGuard();
$404b099c73bb3a1f$var$initSignUpUnhandledRejectionGuard();
const $404b099c73bb3a1f$var$isWebkitAutofilled = function(element) {
    if (!element || typeof element.matches !== 'function') return false;
    try {
        return element.matches(':-webkit-autofill');
    } catch (_err) {
        return false;
    }
};
const $404b099c73bb3a1f$export$cf64224bcd829024 = async function(recaptchaToken) {
    (0, $12U9u.qS)(`#sign_up_next`).classList.add('button-loading');
    if (!recaptchaToken) {
        $404b099c73bb3a1f$var$showRecaptchaBlockedError();
        return;
    }
    const publicId = (0, $hd1sz.getLocalStorageItem)('publicId') || null;
    const usedPublicIdList = (0, $hd1sz.getLocalStorageItem)('usedPublicIdList') || null;
    // Save attribution from local storage
    // Is saved in native app
    // And on home when ?ref= or ?utm_source= is set
    let attribution = JSON.parse((0, $hd1sz.getLocalStorageItem)('utmAttribution')) || null;
    // Split test group is set by URL parameter g=
    // adId is set by native app
    const splitTestGroup = (0, $hd1sz.getLocalStorageItem)('splitTestGroup') || null;
    // Save tag
    const storedTagList = (0, $hd1sz.getLocalStorageItem)('tag');
    const tagList = storedTagList ? storedTagList.split(',') : [];
    // Display name
    const displayName = (0, $12U9u.qS)('#sign_up_display_name').value || null;
    // Hidden honey pot
    const podInput = (0, $12U9u.qS)('#sign_up_pod');
    const pod = (podInput?.value || '').trim();
    if (pod && pod.length > 0) {
        // Chrome Android can autofill hidden fields and trigger false positives.
        if ($404b099c73bb3a1f$var$isWebkitAutofilled(podInput)) podInput.value = '';
        else {
            // Honey pot detected
            (0, $1ry19.error).handle({
                error: $404b099c73bb3a1f$var$honeypotErrorMessage
            }, 'sign_up_terms_container');
            $404b099c73bb3a1f$var$resetSignUpButton();
            (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.signupHoneyPot, {
                email: (0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#sign_up_email').value),
                displayName: displayName,
                pod: pod
            });
            return;
        }
    }
    if (!displayName || displayName.length === 0) {
        (0, $1ry19.error).handle({
            error: (0, $12U9u.publicPage)?.text?.signUpForm?.fullNameRequiredError || 'Please enter your full name'
        }, 'sign_up_display_name_container');
        $404b099c73bb3a1f$var$resetSignUpButton();
        return;
    }
    if (displayName.length >= 40) {
        (0, $1ry19.error).handle({
            error: (0, $4D2XJ.t)('signUpForm.fullNameTooLongError')
        }, 'sign_up_display_name_container');
        $404b099c73bb3a1f$var$resetSignUpButton();
        return;
    }
    if (!(0, $12U9u.isValidDisplayName)(displayName)) {
        (0, $1ry19.error).handle({
            error: (0, $4D2XJ.t)('signUpForm.fullNameInvalidError')
        }, 'sign_up_display_name_container');
        $404b099c73bb3a1f$var$resetSignUpButton();
        return;
    }
    // Terms of use
    if (!(0, $12U9u.qS)('#sign_up_terms').checked) {
        (0, $1ry19.error).handle({
            error: (0, $12U9u.publicPage)?.text?.signUpForm?.acceptTermsError || 'Please accept the terms of use'
        }, 'sign_up_terms_container');
        $404b099c73bb3a1f$var$resetSignUpButton();
        return;
    }
    (0, $12U9u.qS)(`#sign_up_next`).disabled = true;
    try {
        const language = (0, $12U9u.pageLanguage) || (navigator?.language?.startsWith('de') ? 'de' : 'en');
        const email = (0, $12U9u.normalizeEmail)((0, $12U9u.qS)('#sign_up_email').value);
        await (0, $jdIi8.currency).get();
        $404b099c73bb3a1f$var$renderSignUpLead();
        const locationUnavailable = (0, $aMSjD.locationUnavailableFromStoredValue)((0, $hd1sz.getLocalStorageItem)((0, $jdIi8.currency).localStorageItemNameLocationUnavailable));
        const freeMessageCountry = (0, $hd1sz.getLocalStorageItem)((0, $jdIi8.currency).localStorageItemNameCountry);
        console.log('displayName', displayName);
        console.log('email.value', email);
        const redirectedToSso = await (0, $bpqmk.redirectToSsoIfRequired)({
            email: email,
            flow: 'signUp',
            redirect: (0, $12U9u.url).parameters.redirect || '/app/',
            pending: {
                publicId: publicId,
                usedPublicIdList: usedPublicIdList,
                splitTestGroup: splitTestGroup,
                attribution: attribution,
                displayName: displayName,
                tagList: tagList,
                language: language,
                locationUnavailable: locationUnavailable,
                freeMessageCountry: freeMessageCountry
            }
        });
        if (redirectedToSso) return;
        const result = await (0, $8Mqxj.user).create(email, {
            recaptchaToken: recaptchaToken,
            publicId: publicId,
            usedPublicIdList: usedPublicIdList,
            splitTestGroup: splitTestGroup,
            attribution: attribution,
            displayName: displayName,
            tagList: tagList,
            language: language,
            locationUnavailable: locationUnavailable,
            freeMessageCountry: freeMessageCountry
        });
        console.log('result user.create', result);
        if (result.success) {
            await (0, $e6rpZ.activity).log((0, $e6rpZ.activity).activityTypes.signup);
            const verifyHref = (0, $12U9u.publicPage)?.links?.verify?.href || '/verify';
            window.location.href = `${verifyHref}?email=${encodeURIComponent(email)}`;
        } else {
            console.log('result.error', result.error);
            // Show the error where it belongs
            let container;
            if ([
                'DISPLAY_NAME_REQUIRED',
                'DISPLAY_NAME_INVALID',
                'DISPLAY_NAME_FIRST_AND_LAST_REQUIRED',
                'DISPLAY_NAME_LINK_OR_CODE_NOT_ALLOWED'
            ].includes(result.error)) container = 'sign_up_display_name_container';
            else if ([
                'RECAPTCHA_TOKEN_REQUIRED',
                'RECAPTCHA_VALIDATION_FAILED',
                'BELOW_RECAPTCHA_MINIMUM_SCORE'
            ].includes(result.error)) container = 'sign_up_terms_container';
            else if (result.error === 'SSO_REQUIRED') container = 'sign_up_email_container';
            else // If not display name, it's probably a problem with the email address
            container = 'sign_up_email_container';
            (0, $1ry19.error).handle(result, container);
            $404b099c73bb3a1f$var$resetSignUpButton();
        }
    } catch (err) {
        if ($404b099c73bb3a1f$var$isTimeoutError(err)) {
            $404b099c73bb3a1f$var$showTimeoutError();
            return;
        }
        (0, $1ry19.error).handle({
            error: (0, $12U9u.publicPage)?.text?.signUpForm?.genericError || 'Something went wrong. Please try again.'
        }, 'sign_up_terms_container');
        $404b099c73bb3a1f$var$resetSignUpButton();
        console.error('signUp error', err);
    }
};
const $404b099c73bb3a1f$var$authSignUp = function(recaptchaToken) {
    Promise.resolve($404b099c73bb3a1f$export$cf64224bcd829024(recaptchaToken)).catch((err)=>{
        if ($404b099c73bb3a1f$var$isTimeoutError(err)) {
            $404b099c73bb3a1f$var$showTimeoutError();
            return;
        }
        if (typeof err === 'string' && err === 'RECAPTCHA_ERROR') {
            $404b099c73bb3a1f$var$showRecaptchaBlockedError();
            return;
        }
        (0, $1ry19.error).handle({
            error: (0, $12U9u.publicPage)?.text?.signUpForm?.genericError || 'Something went wrong. Please try again.'
        }, 'sign_up_terms_container');
        $404b099c73bb3a1f$var$resetSignUpButton();
        console.error('authSignUp callback error', err);
    });
};
const $404b099c73bb3a1f$var$authSignUpRecaptchaError = function() {
    $404b099c73bb3a1f$var$showRecaptchaBlockedError();
};
const $404b099c73bb3a1f$var$authSignUpRecaptchaExpired = function() {
    (0, $1ry19.error).handle({
        error: 'RECAPTCHA_EXPIRED',
        errorMessage: (0, $12U9u.publicPage)?.text?.signUpForm?.recaptchaExpired || 'Security check expired. Please try again.'
    }, 'sign_up_terms_container');
    $404b099c73bb3a1f$var$resetSignUpButton();
};
// For recaptcha callbacks
window.authSignUp = $404b099c73bb3a1f$var$authSignUp;
window.authSignUpRecaptchaError = $404b099c73bb3a1f$var$authSignUpRecaptchaError;
window.authSignUpRecaptchaExpired = $404b099c73bb3a1f$var$authSignUpRecaptchaExpired;
(0, $jdIi8.currency).get().catch(()=>null).finally($404b099c73bb3a1f$var$renderSignUpLead);

});
parcelRegister("4CIFe", function(module, exports) {

$parcel$export(module.exports, "countryHasFreeMessages", () => $e7727a5146ab93a4$export$a467e20d434ce664);
const $e7727a5146ab93a4$export$9429ba1c722bc838 = Object.freeze([
    'CH',
    'DE',
    'AT'
]);
const $e7727a5146ab93a4$export$a467e20d434ce664 = function(country) {
    return $e7727a5146ab93a4$export$9429ba1c722bc838.includes(String(country || '').trim().toUpperCase());
};

});




//# sourceMappingURL=abmelden.c48d4c74.js.map
